<template>
    <div class="search-widget">
        <input
            type="text"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
        />
        <span class="icon material-symbols-outlined">search</span>
    </div>
</template>
<script>
export default {
    name: "SearchWidget",
    props: {
        modelValue: {
            type: String,
            default: null,
        },
    },
    emits: ["update:modelValue"],
};
</script>
